import { getModelState } from 'client/data/luckdragon/model';
import { InventoryModel } from 'client/data/models/inventory';
import { get, capitalize } from 'lodash-es';
import { getQuery } from 'client/utils/location';
import {
  LOOK_UP_FAILURE_STEP,
  LOOK_UP_STEP,
  PERSONAL_STEP,
  PrequalificationApplicationFlowSteps,
} from 'site-modules/shared/constants/financing/steps';
import {
  PRE_QUALIFICATION_APPLICATION,
  PRE_QUALIFICATION_RESULT,
} from 'site-modules/shared/constants/financing/financing-constants';

export const DEFAULT_SEO_PARAMS = {
  robots: {
    noIndex: true,
    noFollow: true,
  },
};

const createPrefixTitle = (step, query) => {
  const capitalizeStep = capitalize(step);
  if (!PrequalificationApplicationFlowSteps.includes(step)) {
    return `${PRE_QUALIFICATION_RESULT} - `;
  } else if (step !== PERSONAL_STEP) {
    return `${PRE_QUALIFICATION_APPLICATION} - ${capitalizeStep} - `;
  } else if (LOOK_UP_STEP in query) {
    return `${PRE_QUALIFICATION_APPLICATION} - ${capitalizeStep} Look Up - `;
  } else if (LOOK_UP_FAILURE_STEP in query) {
    return `${PRE_QUALIFICATION_APPLICATION} - ${capitalizeStep} Look Up Failure - `;
  }
  return `${PRE_QUALIFICATION_APPLICATION} - ${capitalizeStep} - `;
};

/**
 * Get seo object
 * @returns {object}
 */
export const getSeoObject = (state, props) => {
  const { vin, step } = props.match.params;
  const query = getQuery(props.location);
  const modelState = getModelState(state);
  const vinPath = `vin["${vin}"]`;
  const vinData = modelState.get(vinPath, InventoryModel);
  if (!vinData) return DEFAULT_SEO_PARAMS;
  const { make, model, year } = get(vinData, 'vehicleInfo.styleInfo');
  const basicTile = `${year} ${make} ${model} | Edmunds`;
  const prefixTitle = createPrefixTitle(step, query);
  const title = prefixTitle + basicTile;

  return { ...DEFAULT_SEO_PARAMS, title };
};
